module.exports = __webpack_public_path__ + "static/media/rb.061d7316.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/img/rb.svg
// module id = 360
// module chunks = 0